import { Theme } from '@emotion/react';

export const generateArticlesStyles = (theme: Theme) => ({
    wrapper: {
        // No direct styles, but used for nesting
    },
    title: {
        marginBottom: '34px',
        fontSize: '16px',
        letterSpacing: 0,
        fontWeight: 500,
        fontFamily: theme.palette.common.font,
    },
    cards: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gridTemplateRows: 'repeat(2, 2fr)',
        gridColumnGap: '64px',
        gridRowGap: '64px',
    },
});
